export function updateSettings(data) {
  return { type: 'SETTINGS_UPDATE', data };
}

export function settingsError(error) {
  return { type: 'SETTINGS_ERROR', error };
}